import { ONBOARDING_PAPER_CLASS_NAME, HOME_INFO_CARD_PAPER_CLASS_NAME } from '../../constants/paper';
import { SELECT_MENU_CLASS_NAME, FORM_SELECT_MENU_CLASS_NAME } from '../../constants/select';

export const selectMenuStyles = ({ theme, mainSelectColor }) => ({
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
  marginTop: 8,
  color: '#232323',
  minWidth: 220,
  border: `1px solid ${theme.palette.primary.A300}`,
  [theme.breakpoints.down('md')]: {
    minWidth: 150,
  },
  '& .MuiMenuItem-root': {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: theme.typography.small_3.fontSize,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.small_2.fontSize,
    },
    fontWeight: 400,
    '&.Mui-selected': {
      color: mainSelectColor,
      backgroundColor: theme.palette.primary.A100,
    },
    '&:hover': {
      color: mainSelectColor,
    },
  },
  // Disabled MenuItems need pointer-events so tooltips can show on hover;
  // :active sets pointer-events none so the option still cannot be selected.
  '& .MuiMenuItem-root[aria-disabled="true"]': {
    pointerEvents: 'inherit',
  },
  '& .MuiMenuItem-root[aria-disabled="true"]:active': {
    pointerEvents: 'none',
  },
});

export const formSelectMenuStyles = ({ theme, mainSelectColor }) => ({
  ...selectMenuStyles({ theme, mainSelectColor }),
  border: `1px solid ${theme.palette.gray.A300}`,
  boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
  '& .MuiMenuItem-root': {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: theme.typography.small_3.fontSize,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.small_2.fontSize,
    },
    fontWeight: 400,
    '&.Mui-selected': {
      color: theme.palette.gray.A700,
      backgroundColor: theme.palette.gray.A100,
    },
    '&:hover': {
      color: theme.palette.gray.A700,
      backgroundColor: theme.palette.gray.A100,
    },
    '&[data-value=""]': {
      display: 'none',
    },
  },
});

export const homeInfoCardPaperStyles = ({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: '0 18px 32px 0 rgba(208, 210, 218, 0.15)',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  [theme.breakpoints.up('md')]: {
    width: 250,
    height: 60,
  },
  [theme.breakpoints.up('lg')]: {
    width: 300,
    height: 79,
  },
  boxSizing: 'border-box',
  overflow: 'visible',
});

const MuiPaper = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${ONBOARDING_PAPER_CLASS_NAME}`]: {
        backgroundColor: 'white',
        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: 20,
      },
      [`&.${HOME_INFO_CARD_PAPER_CLASS_NAME}`]: homeInfoCardPaperStyles({ theme }),
      [`&.${SELECT_MENU_CLASS_NAME}`]: selectMenuStyles({ theme, mainSelectColor: theme.palette.primary.main }),
      [`&.${FORM_SELECT_MENU_CLASS_NAME}`]: formSelectMenuStyles({ theme, mainSelectColor: theme.palette.primary.main }),
    }),
  },
};

export default MuiPaper;
